import { css } from "@emotion/css"

export const progressWrapper = css`
  margin-bottom: var(--spacing-m);
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
`

export const image = css`
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
`

export const column = css`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const filename = css`
  margin-bottom: 0.1rem;
`

export const progressIcon = css`
  padding: 12px 0 0 12px;
`

export const formWrapper = css`
  width: 28rem;
`
